import { SITE_STAGES,SITE_ISSUES_LIST, SAVE_STAGES_DOCUMENTS } from "./type";

const initalState = {
  siteStageData: [],
  siteIssuesList: [],
  saveStagesDocuments: []
};

const siteStageReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SITE_STAGES:
      return {
        ...state,
        siteStageData: payload,
      };
    case SITE_ISSUES_LIST:
      return {
        ...state,
        siteIssuesList: payload,
      };
    case SAVE_STAGES_DOCUMENTS:
      return {
        ...state,
        saveStagesDocuments: payload,
      };  
    default:
      return {
        ...state,
      };
  }
};

export default siteStageReducer;
